export enum DialogState {InputAmount = 1, ConfirmationType = 2, CodeInput = 3, Finish = 4, Verification = 5}